import { black, gray6, mainDeepGreen, white } from "assets/styleUtil";
import StationArrowSvg from "assets/svg/StationArrowSvg";
import StationSvg from "assets/svg/StationSvg";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import gwacheonStation from "../assets/images/gwacheonStation.png";

const TrainDataContainer = styled.div<{ width: string }>`
  width: ${(props) => props.width};
  // border: 1px solid #e0e0e0;
  max-height: 800px;
`;

const TrainData = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  background: #f9f9f9;
  border-bottom: 1px solid #828282;
  padding: 10px 0;
`;

export default function SubwayPage() {
  const [upTrain, setUpTrain] = useState<string[]>([]);
  const [downTrain, setDownTrain] = useState<string[]>([]);

  const getData = () => {
    const xhr = new XMLHttpRequest();
    const url = `http://swopenapi.seoul.go.kr/api/subway/6969466745616c7338387a626a5465/xml/realtimeStationArrival/0/5/%EA%B3%BC%EC%B2%9C`;
    xhr.open(
      "GET",
      window.location.hostname === "localhost"
        ? "http://swopenapi.seoul.go.kr/api/subway/6969466745616c7338387a626a5465/xml/realtimeStationArrival/0/5/%EA%B3%BC%EC%B2%9C"
        : `/swopenapi/api/subway/6969466745616c7338387a626a5465/xml/realtimeStationArrival/0/5/과천`
    );
    xhr.onreadystatechange = function () {
      if (this.readyState == xhr.DONE) {
        // <== 정상적으로 준비되었을때
        if (xhr.status == 200 || xhr.status == 201) {
          // <== 호출 상태가 정상적일때
          // console.log(
          //   "Status: " +
          //     this.status +
          //     "\nHeaders: " +
          //     JSON.stringify(this.getAllResponseHeaders()) +
          //     "\nBody: " +
          //     this.responseText
          // );
          extractUpwardTrains(this.responseText);
        }
        // 승인받으면 아래 주석으로 바꾸기
        // extractUpwardTrains(
        //   "<realtimeStationArrival><RESULT><code>INFO-000</code><developerMessage></developerMessage><link></link><message>정상 처리되었습니다.</message><status>200</status><total>4</total></RESULT><row><rowNum>1</rowNum><selectedCount>4</selectedCount><totalCount>4</totalCount><subwayId>1004</subwayId><updnLine>상행</updnLine><trainLineNm>당고개행 - 대공원방면</trainLineNm><statnFid>1004000439</statnFid><statnTid>1004000437</statnTid><statnId>1004000438</statnId><statnNm>과천</statnNm><trnsitCo>1</trnsitCo><ordkey>01004당고개0</ordkey><subwayList>1004</subwayList><statnList>1004000438</statnList><btrainSttus>일반</btrainSttus><barvlDt>0</barvlDt><btrainNo>4700</btrainNo><bstatnId>0</bstatnId><bstatnNm>당고개</bstatnNm><recptnDt>2023-11-15 21:58:49</recptnDt><arvlMsg2>[4]번째 전역 (범계)</arvlMsg2><arvlMsg3>범계</arvlMsg3><arvlCd>99</arvlCd></row><row><rowNum>2</rowNum><selectedCount>4</selectedCount><totalCount>4</totalCount><subwayId>1004</subwayId><updnLine>상행</updnLine><trainLineNm>당고개행 - 대공원방면</trainLineNm><statnFid>1004000439</statnFid><statnTid>1004000437</statnTid><statnId>1004000438</statnId><statnNm>과천</statnNm><trnsitCo>1</trnsitCo><ordkey>02008당고개0</ordkey><subwayList>1004</subwayList><statnList>1004000438</statnList><btrainSttus>일반</btrainSttus><barvlDt>0</barvlDt><btrainNo>4702</btrainNo><bstatnId>0</bstatnId><bstatnNm>당고개</bstatnNm><recptnDt>2023-11-15 21:58:49</recptnDt><arvlMsg2>[8]번째 전역 (대야미)</arvlMsg2><arvlMsg3>대야미</arvlMsg3><arvlCd>99</arvlCd></row><row><rowNum>3</rowNum><selectedCount>4</selectedCount><totalCount>4</totalCount><subwayId>1004</subwayId><updnLine>하행</updnLine><trainLineNm>오이도행 - 정부과천청사방면</trainLineNm><statnFid>1004000437</statnFid><statnTid>1004000439</statnTid><statnId>1004000438</statnId><statnNm>과천</statnNm><trnsitCo>1</trnsitCo><ordkey>11002오이도0</ordkey><subwayList>1004</subwayList><statnList>1004000438</statnList><btrainSttus>일반</btrainSttus><barvlDt>0</barvlDt><btrainNo>4703</btrainNo><bstatnId>53</bstatnId><bstatnNm>오이도</bstatnNm><recptnDt>2023-11-15 21:59:18</recptnDt><arvlMsg2>[2]번째 전역 (경마공원)</arvlMsg2><arvlMsg3>경마공원</arvlMsg3><arvlCd>99</arvlCd></row><row><rowNum>4</rowNum><selectedCount>4</selectedCount><totalCount>4</totalCount><subwayId>1004</subwayId><updnLine>하행</updnLine><trainLineNm>오이도행 - 정부과천청사방면</trainLineNm><statnFid>1004000437</statnFid><statnTid>1004000439</statnTid><statnId>1004000438</statnId><statnNm>과천</statnNm><trnsitCo>1</trnsitCo><ordkey>12005오이도0</ordkey><subwayList>1004</subwayList><statnList>1004000438</statnList><btrainSttus>일반</btrainSttus><barvlDt>0</barvlDt><btrainNo>4705</btrainNo><bstatnId>53</bstatnId><bstatnNm>오이도</bstatnNm><recptnDt>2023-11-15 21:59:18</recptnDt><arvlMsg2>[5]번째 전역 (사당)</arvlMsg2><arvlMsg3>사당</arvlMsg3><arvlCd>99</arvlCd></row></realtimeStationArrival>"
        // );
      }
    };
    xhr.send("");
  };

  const extractUpwardTrains = (xmlString: any) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "text/xml");
    const rows = xmlDoc.getElementsByTagName("row");
    const upwardTrains: string[] = [];
    const downwardTrains = [];

    for (let i = 0; i < rows.length; i++) {
      const updnLine =
        rows[i].getElementsByTagName("updnLine")[0].childNodes[0].nodeValue;
      if (updnLine === "상행") {
        const arvlMsgElement = rows[i].getElementsByTagName("arvlMsg2")[0];
        if (arvlMsgElement && arvlMsgElement.childNodes.length > 0) {
          const arvlMsg2 = arvlMsgElement.childNodes[0].nodeValue;
          if (arvlMsg2) {
            upwardTrains.push(arvlMsg2);
          }
        }
      } else {
        const arvlMsgElement = rows[i].getElementsByTagName("arvlMsg2")[0];
        if (arvlMsgElement && arvlMsgElement.childNodes.length > 0) {
          const arvlMsg2 = arvlMsgElement.childNodes[0].nodeValue;
          if (arvlMsg2) {
            downwardTrains.push(arvlMsg2);
          }
        }
      }
    }
    const filteredTrains = upwardTrains.filter((train) => {
      const match = train.match(/\d+/);
      return match ? parseInt(match[0], 10) < 10 : true;
    });

    const sortedData = filteredTrains.sort((a, b) => {
      // "과천"을 포함하는 문자열은 우선순위 최상위로 배치
      if (a.includes("과천")) return -1;
      if (b.includes("과천")) return 1;

      // 문자열에서 숫자 추출
      const matchA = a.match(/\d+/);
      const matchB = b.match(/\d+/);
      const numA = parseInt(matchA ? matchA[0] : "0", 10);
      const numB = parseInt(matchB ? matchB[0] : "0", 10);

      // 숫자가 있는 경우 오름차순 정렬, 없는 경우 원래 순서 유지
      return numA - numB;
    });
    setUpTrain(sortedData);
    setDownTrain(downwardTrains);
  };

  useEffect(() => {
    getData();
    const intervalId = setInterval(() => {
      getData();
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "50%",
          height: "65px",
          backgroundColor: mainDeepGreen,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: white,
            fontSize: "15px",
            fontWeight: "700",
            marginTop: "10px",
          }}
        >
          현재시간
        </div>
        <div
          style={{
            color: white,
            fontSize: "18px",
            fontWeight: "700",
          }}
        >
          {moment().format("HH:mm")}
        </div>
      </div>
      <div style={{ display: "flex", width: "90%", marginTop: "40px" }}>
        {/* <div style={{ marginRight: "-20px" }}>
          <StationArrowSvg transform="scale(-1, 1) translate(-550, 0)" />
        </div>
        <StationSvg width={"200px"} />
        <div style={{ marginLeft: "-20px" }}>
          <StationArrowSvg />
        </div> */}
        <img src={gwacheonStation} style={{ width: "100%" }} />
      </div>
      <div
        style={{
          width: "100%",
          color: black,
          fontSize: "20px",
          fontWeight: "bold",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 60px 0 30px",
          }}
        >
          <div>정부과천청사역</div>
          <div>대공원역</div>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          marginTop: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "550px",
              padding: "0 20px 0 20px",
            }}
          >
            <TrainDataContainer width={"150px"}>
              {downTrain.map((data, index) => {
                return (
                  <TrainData key={index}>
                    {data.includes("(") ? (
                      <>
                        {data.split(" ")[0] + " " + data.split(" ")[1]}
                        <br />
                        {data.split(" ")[2]}
                      </>
                    ) : (
                      data
                    )}
                  </TrainData>
                );
              })}
            </TrainDataContainer>
            <TrainDataContainer width={"150px"}>
              {upTrain.map((data, index) => {
                return (
                  <TrainData key={index}>
                    {data.includes("(") ? (
                      <>
                        {data.split(" ")[0] + " " + data.split(" ")[1]}
                        <br />
                        {data.split(" ")[2]}
                      </>
                    ) : (
                      data
                    )}
                  </TrainData>
                );
              })}
            </TrainDataContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
